(function () {

  'use strict';

  angular.module('eclipseApp.components').directive('merchantAddressInfo', function () {
    return {
      restrict: 'AE',
      scope: true,
      replace: true,
      templateUrl: 'modules/components/views/merchant-address-details.html',
      link: function ($scope, $element, $attr) {
        $scope.flowName = $attr.flowName;
        if ($scope.flowName === 'changeMOP') {
          if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
            $scope.breakLine = true;
          $scope.rowClass = "changeMOPFlow";
        }
        if ($scope.flowName === 'payNowEnhance') {
          $scope.flowClass = "payNowEnhance";
          $scope.rowClass = "payNowRow";
          $scope.$watch(function () {return $('#merchantBar').innerWidth();},
            function (newValue, oldValue) {
              console.log($('#merchantBar').innerWidth());
              if (newValue <= 400 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                $scope.breakLine = true;
                $('.address-info').addClass('pay-now-initial-screen');
                $('#merchantBar').addClass('pay-now-row-initial-screen');
              }
              else if (newValue > 400) {
                $scope.breakLine = false;
                $('.address-info').removeClass('pay-now-initial-screen').addClass('pay-now-next-screen');
                $('#merchantBar').removeClass('pay-now-row-initial-screen');
              }
          });
        }
        if ($scope.flowName === 'autoPayPlan' || $scope.flowName === 'registerCreditCard' || $scope.flowName === 'autoRefillBalance'
         || $scope.flowName === 'refillOneTimeRefill' || $scope.flowName === 'refillOneTimeRefillReview') {
         // $scope.rowClass = 'no-left-margin';
          $scope.rowClass = "prepaidFlowMerchantInfo";
          if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
            $scope.breakLine = true;
        }
      },
      controller: ['$scope', function ($scope) {
        console.log($scope.flowName);

      }]
    };
  });


})();

